<template>
  <app-layout class="page__recorder-outside">
    <template v-slot:space>
      <remember class="record__remember" v-if="recording">
        <li>Inhale deeply through your nose</li>
        <li>Cough without covering your mouth</li>
        <li>Repeat (inhale and cough) for a total of 3 coughs</li>
      </remember>
      <div v-else-if="audioSource" class="record__audio-description">
        Review your recording (optional). If you hear background noise or did
        not exert maximum effort, delete and record again.
      </div>
      <instructions v-else />
      <record-shared
        @send-voice="sendHandler"
        :disabled="loading"
        :min-duration="minDuration"
        :voiceKey="voiceKey"
        :route="currentRoute"
        inline
      />
    </template>
  </app-layout>
</template>

<script>
import AppLayout from "@/components/appLayout";
import Instructions from "./components/instructions";
import RecordShared from "@/components/record";
import RecordMixin from "@/mixins/record";
import RouteMixin from "@/mixins/routing";
import Remember from "@/components/remember";
import logVisiting from "@/mixins/logVisiting";

import {
  ROUTE_THREE_STRONG_COUGHS,
  ROUTE_READING_PASSAGE,
  RECORD_MIN_DURATION_TSC,
} from "@/constants";

export default {
  name: "ThreeStrongCoughs",
  components: { AppLayout, Instructions, RecordShared, Remember },
  mixins: [RecordMixin, RouteMixin, logVisiting],

  data: () => ({
    voiceKey: "audio4",
    currentRoute: ROUTE_THREE_STRONG_COUGHS,
    nextRoute: ROUTE_READING_PASSAGE,
    type: "record",
    minDuration: RECORD_MIN_DURATION_TSC,
  }),
};
</script>
